



















import Vue from 'vue'

export default Vue.extend({
    name: 'Links',

    data: () => ({

    }),
    methods: {

    }
})
